<script>
export default {
  name: "ColorInternarStatus",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    //const SlaDaysToResponse = context.props.row.SlaDaysToResponse;
    //const DiasRetrasadosSla = context.props.row.DiasRetrasadosSla;
    //console.log("Contexto: ", context);
    const StatusSlaDescripcion = context.props.row.StatusSlaDescripcion;
    const StatusDesc = context.props.row.Estado; // este se usa para kpi de tareas
    const StatusSolicitud = context.data.attrs.rowValue;

    if (
      StatusSlaDescripcion == "En Atraso" ||
      StatusSlaDescripcion == "Retrasado" ||
      StatusSolicitud == "Retrasado"
    ) {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--plain"
        },
        "En Atraso"
      );
    } else if (
      StatusSlaDescripcion == "Al Dia" ||
      StatusSolicitud == "Al Dia"
    ) {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--success el-tag--plain"
        },
        "Al Día"
      );
    } else if (StatusDesc == "Abiertas retrasadas") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--plain"
        },
        "Abierta retrasada"
      );
    } else if (StatusDesc == "Cerrada tarde") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--plain"
        },
        "Cerrada tarde"
      );
    } else if (StatusDesc == "Cerrada a tiempo") {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--success el-tag--plain"
        },
        "Cerrada a tiempo"
      );
    } else if (StatusDesc == "Abiertas a tiempo") {
      return createElement(
        "span",
        {
          class: "el-tag  el-tag--success el-tag--plain"
        },
        "Abierta a tiempo"
      );
    }

    return createElement(
      "span",
      {
        class: "el-tag  el-tag--danger el-tag--plain"
      },
      "Error!"
    );
  }
};
</script>
